import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output, ViewChild
} from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl, FormControlDirective,
  NG_VALUE_ACCESSOR,
  NonNullableFormBuilder,
  ReactiveFormsModule,
} from "@angular/forms";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {Backend} from '@generated-backend-types';
import TableFilterFavorite = Backend.App.Resources.Dashboard.Settings.TableFilterFavorite;
import {TableDisplayConfig} from '../../../entities/table-display-config.entity';
import {FormErrorService} from '../../../services/form-error.service';
import {TableFilterFavoritesService} from '../../../services/api/settings/table-filter-favorites.service';
import {NgIf} from '@angular/common';
import {
  MultiSelectWithServiceComponent
} from '../../form-inputs/multi-select-with-service/multi-select-with-service.component';

@Component({
  selector: 'app-table-favorite-selector[formControl][reloadFavorites]',
  templateUrl: './table-favorite-selector.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: TableFavoriteSelectorComponent,
    multi: true
  }],
  imports: [ReactiveFormsModule, NgIf, MultiSelectWithServiceComponent, TranslatePipe],
  standalone: true
})
export class TableFavoriteSelectorComponent implements ControlValueAccessor {

  @Input() public formControl!: FormControl<TableFilterFavorite[] | undefined>;

  @Output() public favoriteDeleted: EventEmitter<void> = new EventEmitter<void>();


  @Input()
  public reloadFavorites!: EventEmitter<void>

  @Input() showFavorites = true;

  @ViewChild(FormControlDirective, {static: true})
  public formControlDirective?: FormControlDirective;


  public _tableDisplayConfig?: TableDisplayConfig;
  @Input()
  public set tableDisplayConfig(conf: TableDisplayConfig | undefined) {
    if (!conf) {
      return;
    }
    this._tableDisplayConfig = conf;
  }

  public deleteFavorite() {
    if (
      !this.formControl.value?.at(0)?.id
    ) {
      return
    }
    this.tableFilterFavoriteService.delete(this.formControl.value[0].id).subscribe(
      () => {
        this.reloadFavorites.emit()
        this.favoriteDeleted.emit()
        this.toastrService.success(
          this.translate.instant('table_filter.deleted_success')
        );
      }
    )
  }


  registerOnTouched(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
  }

  registerOnChange(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.registerOnChange(fn);
  }

  writeValue(obj: string[] | string | null): void {
    this.formControlDirective?.valueAccessor?.writeValue(obj);
  }

  setDisabledState(): void {
    // da formControl und control identisch sind brauchen wir hier nichts weiter zu geben
  }

  public constructor(
    protected cdr: ChangeDetectorRef,
    protected translate: TranslateService,
    readonly tableFilterFavoriteService: TableFilterFavoritesService,
    private readonly fb: NonNullableFormBuilder,
    private readonly nfb: FormBuilder,
    private readonly formErrorService: FormErrorService,
    private readonly toastrService: ToastrService
  ) {}
}
